import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Spinner from '../../Spinner';

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  '& .closeButton': {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

export default function UploadDialog(props) {
  const {open, setOpen, uploading, navigate} = props;

  const handleClose = () => {
    setOpen(false);
    // If navigation is needed, use the navigate function
    // navigate('/');
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth={true} maxWidth={'sm'}>
        <StyledDialogTitle id="customized-dialog-title">
          {uploading ? 'Updating...' : 'Done'}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="closeButton"
            size="small"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <StyledDialogContent dividers>
            {uploading && <Spinner />}
        </StyledDialogContent>
        <StyledDialogActions>
            {!uploading && 
            <Button autoFocus onClick={handleClose} color="primary">
                OK
            </Button>}
        </StyledDialogActions>
    </Dialog>
  );
}